// extracted by mini-css-extract-plugin
export default {"image":"GFRjTuje15","hasError":"FB3QiUEMbS"};